import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const setAvatar = async (image: FormData): Promise<AxiosResponse> =>
  AxiosInstance.post('users.setAvatar', image, {
    headers: {
      'content-type': 'multipart/form-data;',
    },
  });
